module.exports = __webpack_public_path__ + "img/banner2-3@1x.62635ca4.jpg";